import moment from "moment";
import FeatherIcon from "feather-icons-react";
import { formatMoneyWithCurrency, formatRut } from "src/utils/formatter";
import SVG_BANKS from "../../assets/svg/svg_banks";

import { documentsDic } from "src/utils/dataDictionary";
import { useSelector } from "react-redux";

export const ResultsCard = (
  {
    results,
    saveSearch,
    resultsName,
    onModalClose,
    searchTerm
  }) => {
  const companyId = useSelector((state) => {
    return state.companyList.selectedCompany.id;
  });

  const handleRedirect = (result) => {
    const entityName = result?.entity || resultsName;
    onModalClose();
    saveSearch({ ...result, entity: entityName });
    if (entityName == "Agendas") {
      window.location.href = `/agenda?companyId=${companyId}&idAgenda=${result?.id}&search=${result?.rut}&page=1&offset=20`;
    }

    if (entityName == "Documentos") {
      window.location.href = `/documentos_tributarios?type=ALL&page=1&offset=20&id=${result?.id}&isGlobalSearch=true`;
    }

    if (entityName == "Movimientos") {
      window.location.href = `/conciliacion?type=ALL&page=1&offset=20&id=${result?.id}`;
    }
  };

  const seeAll = () => {
    if (resultsName == "Agendas") {
      window.location.href = `/agenda`;
    }

    if (resultsName == "Documentos") {
      window.location.href = `/documentos_tributarios`;
    }

    if (resultsName == "Movimientos") {
      window.location.href = `/conciliacion`;
    }
  };

  return (
    (results && results?.length) > 0 && (
      <section className="tw-w-full tw-flex tw-flex-col tw-gap-2">
        <span className="tw-text-xs tw-font-semibold tw-text-gray-800">
          {resultsName}
        </span>

        <div className="tw-w-full">
          {results.slice(0, resultsName == 'Últimas búsquedas' ? 5 : 3).map((result) => {
            const entityName = result?.entity || resultsName;
            return (
              <div
                className="tw-w-full tw-h-[28px] tw-p-1 tw-flex tw-items-center tw-justify-between tw-gap-3 tw-cursor-pointer hover:tw-bg-gray-100"
                onClick={() => handleRedirect(result)}
              >
                <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
                  {entityName == "Documentos" ? (
                    <FeatherIcon
                      icon="file"
                      size={20}
                      strokeWidth={1.5}
                      className="tw-text-gray-500"
                    />
                  ) : entityName == "Movimientos" ? (
                    <img
                      src={SVG_BANKS(result?.bankId)}
                      alt=""
                      className="tw-w-[20px] tw-h-[20px]"
                    />
                  ) : (
                    <FeatherIcon
                      icon="user"
                      size={20}
                      strokeWidth={1.5}
                      className="tw-text-gray-500"
                    />
                  )}
                  <div className="tw-flex tw-gap-1">
                    <span className="tw-max-w-[258px] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-block tw-text-sm tw-text-gray-800">
                      {
                        entityName == "Documentos"
                          ? result?.meta?.isReceived
                            ? result?.meta?.issuerName
                            : result?.meta?.receiverName
                          : entityName == "Movimientos"
                            ? result?.description
                            : result?.name
                      }
                    </span>
                    <span>
                      {
                        formatRut(entityName == "Documentos" &&
                          result?.meta?.isReceived
                          ? result?.meta?.issuerId
                          : result?.meta?.receiverId
                        )
                      }
                    </span>
                  </div>
                </div>

                <div className="tw-flex tw-items-center tw-gap-1 tw-text-xs tw-text-gray-600">
                  {(entityName == "Documentos" ||
                    entityName == "Movimientos") && (
                      <span>{formatMoneyWithCurrency(result?.amount) || 0}</span>
                    )}

                  {entityName === "Agendas" && (
                    <>
                      <span>{formatRut(result?.rut)}</span>

                      {result?.isClient && (
                        <div
                          className={`tw-bg-green-50 tw-h-[16px] tw-px-1 tw-rounded`}
                        >
                          <p
                            className={`tw-text-green-700 !tw-m-0 tw-font-normal`}
                          >
                            Cliente
                          </p>
                        </div>
                      )}

                      {result?.isProvider && (
                        <div
                          className={`tw-bg-red-50 tw-h-[16px] tw-px-1 tw-rounded`}
                        >
                          <p
                            className={`tw-text-red-700 !tw-m-0 tw-font-normal`}
                          >
                            Proveedor
                          </p>
                        </div>
                      )}
                    </>
                  )}
                  {entityName === "Documentos" && (
                    <>
                      {
                        result?.meta?.documentId &&
                        <span>#{result?.meta?.documentId}</span>
                      }

                      <span className=" tw-font-medium tw-text-cs tw-min-w-16 tw-max-w-28 tw-overflow-ellipsis tw-overflow-hidden tw-whitespace-nowrap">
                        {
                          result.documentType == "OBLIGATION"
                            ? result.meta?.typeLabel || ""
                            : documentsDic[parseInt(result.meta.documentCode)]
                              ?.fullName || result.meta.summary
                        }
                      </span>

                      <span className="tw-capitalize">
                        {`${moment(result?.documentDate).format(
                          "MMM"
                        )} ${moment(result?.documentDate).format(
                          "DD"
                        )} ${moment(result?.documentDate).format("YYYY")}`}
                      </span>

                      <div
                        className={`${result?.meta?.isReceived
                          ? "tw-bg-red-50"
                          : "tw-bg-green-50"
                          } tw-h-[16px] tw-px-1 tw-rounded`}
                      >
                        <p
                          className={`${result?.meta?.isReceived
                            ? "tw-text-red-700"
                            : "tw-text-green-700"
                            }  !tw-m-0 tw-font-normal`}
                        >
                          {result?.meta?.isReceived ? "Recibido" : "Emitido"}
                        </p>
                      </div>
                    </>
                  )}

                  {entityName === "Movimientos" && (
                    <>
                      <span className="tw-capitalize">
                        {result?.stringDate
                          ? `${moment(result?.stringDate, 'DD/MM/YYYY').format(
                            "MMM"
                          )} ${moment(result?.stringDate, 'DD/MM/YYYY').format(
                            "DD"
                          )} ${moment(result?.stringDate, 'DD/MM/YYYY').format("YYYY")}`
                          : ""}
                      </span>

                      <div
                        className={`${result?.type == "RECIEVED"
                          ? "tw-bg-green-50"
                          : "tw-bg-red-50"
                          } tw-h-[16px] tw-px-1 tw-rounded`}
                      >
                        <p
                          className={`${result?.type == "RECIEVED"
                            ? "tw-text-green-700"
                            : "tw-text-red-700"
                            }  !tw-m-0 tw-font-normal`}
                        >
                          {result?.type == "RECIEVED" ? "Abono" : "Cargo"}
                        </p>
                      </div>
                    </>
                  )}
                </div>
              </div>
            );
          })}
        </div>

        {
          resultsName != 'Últimas búsquedas' &&
          <button
            className="tw-bg-transparent tw-border-none tw-w-fit tw-px-2 tw-py-1 tw-text-xs tw-text-[#0099ff]"
            onClick={() => seeAll()}
          >
            {resultsName == "Movimientos"
              ? "Ir a conciliación bancaria"
              : resultsName == "Documentos"
                ? "Ir a documentos"
                : "Ir a contactos"}
          </button>
        }
      </section>
    )
  );
};
